import { render, staticRenderFns } from "./AcoesAbrirMensagens.vue?vue&type=template&id=90137376&scoped=true"
import script from "./AcoesAbrirMensagens.vue?vue&type=script&lang=js"
export * from "./AcoesAbrirMensagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90137376",
  null
  
)

export default component.exports